module.exports = __webpack_public_path__ + "static/media/br-chinatown.f046e621.gif";